/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */

/**
 * ###
 * ___
 * Function that exports the smoothscroll.polyfill() method
 * ___
 * #### How to use this function ?
 * Import like this in the component:
 *
 * ```js
 * import { SmoothScroll } from './utils/smooth-scroll';
 * ```
 * Then use the function like the following:
 *
 * ```js
 * SmoothScroll.enable()
 * ```
 *
 */
import './smoothscroll-polyfill-es-build.js';

export class SmoothScroll {
  static enable() {
    window.____smoothscroll.polyfill();
  }
}
